<div class="item-comments d-flex align-items-center column-gap-1">
  <!-- <img
    style="cursor: context-menu"
    src="img/icons/comment_icon_green.png"
    class="item-comments-img m-0"
  /> -->
  <i class="inm-icon-comment"></i>

  <span style="cursor: context-menu"
    >{{ valuations() }}
    {{
      (valuations() === 0
        ? '$valuations_text'
        : valuations() > 1
          ? '$valuations_text_plural'
          : '$valuations_text_singular'
      ) | translate
    }}</span
  >
</div>
